var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H22C20.9 18 20 18.9 20 20V44C20 45.1 20.9 46 22 46H42C43.1 46 44 45.1 44 44V20C44 18.9 43.1 18 42 18ZM38 40H26V38H38V40ZM38 36H26V34H38V36ZM38 32H26V30H38V32ZM38 28H26V26H38V28ZM40 22H24V24H40V22Z",
    fill: "#0B7EE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.525e7192fcfa81fee2d32807cfbf31d2.svg";
export { ForwardRef as ReactComponent };